/* Web-Audio synthesised notification chime + vibration for new orders.
   Uses oscillators so no external audio file is needed. */

const STORAGE_KEY = "c24_sound_enabled";

let audioCtx = null;
function getCtx() {
    if (audioCtx && audioCtx.state !== "closed") return audioCtx;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
    return audioCtx;
}

/** Plays a single tone */
function tone(ctx, freq, startTime, duration = 0.18, gain = 0.25) {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    g.gain.setValueAtTime(0, startTime);
    g.gain.linearRampToValueAtTime(gain, startTime + 0.01);
    g.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(startTime);
    osc.stop(startTime + duration + 0.02);
}

/** Plays a 3-note rising chime (E5 – G5 – C6). Repeats `repeat` times. */
export function playNewOrderChime(repeat = 2) {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const now = ctx.currentTime;
    const NOTES = [
        [659.25, 0.0],   // E5
        [783.99, 0.18],  // G5
        [1046.5, 0.36],  // C6
    ];
    for (let r = 0; r < repeat; r++) {
        const offset = r * 0.9;
        NOTES.forEach(([f, t]) => tone(ctx, f, now + offset + t, 0.22, 0.28));
    }
    // Vibration on mobile (no-op on desktop)
    if ("vibrate" in navigator) {
        try { navigator.vibrate([180, 80, 180, 80, 250]); } catch { /* ignore */ }
    }
}

/** Short test beep (used by the "test sound" button) */
export function playTestBeep() {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    tone(ctx, 880, ctx.currentTime, 0.15, 0.3);
}

export function isSoundEnabled() {
    return localStorage.getItem(STORAGE_KEY) !== "0";
}

export function setSoundEnabled(enabled) {
    localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
}

/** Must be called from a user gesture (click) to unlock audio on iOS Safari. */
export function unlockAudio() {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
}
